module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/google-plus-219c46162f28df713fe8fbc1d6ea15ac.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/google-plus.svg
// module id = lkb0
// module chunks = 24